import React from 'react';
import { ExternalLink, Star } from 'lucide-react';
import { Button } from './ui/button';

const FunGallery = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-logo-teal-light via-white to-cream-bg">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-2 rounded-full text-sm font-bold tracking-wider flex items-center gap-2">
              <Star className="w-4 h-4" />
              PREMIUM OPTION
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-logo-navy vintage-title mb-4">
            Premium Digital Vintage Photo Booth
          </h2>
          <p className="text-xl text-logo-navy-light max-w-2xl mx-auto">
            Cutting-edge digital technology with vintage charm - unlimited photos, instant sharing & more!
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="group relative mb-12">
            {/* Premium badge */}
            <div className="absolute -top-4 -right-4 z-10 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-full shadow-lg transform rotate-12 font-bold">
              <Star className="w-5 h-5 inline mr-1" />
              Premium
            </div>
            
            {/* Polaroid frame effect */}
            <div className="bg-white p-6 pb-20 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-300 border-4 border-purple-500/30">
              <div className="aspect-video overflow-hidden bg-gray-100 rounded-lg">
                <img 
                  src="https://customer-assets.emergentagent.com/job_nostalgic-shots-14/artifacts/s82qcvcs_IMG_6383.JPG"
                  alt="Premium Digital Vintage Photo Booth - Making Memories"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Polaroid caption */}
              <p className="text-center mt-6 text-logo-navy font-handwriting text-2xl">
                Making Memories
              </p>
            </div>
          </div>
          
          {/* Simplified Premium Features & Pricing */}
          <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-purple-500/30">
            <h3 className="text-2xl font-bold text-logo-navy mb-6 text-center">
              Why Choose Premium Digital?
            </h3>
            
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="font-semibold text-logo-navy text-sm">Unlimited Photos</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="font-semibold text-logo-navy text-sm">Social Sharing</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="font-semibold text-logo-navy text-sm">Video Booth</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">✓</span>
                </div>
                <p className="font-semibold text-logo-navy text-sm">No Electricity!</p>
              </div>
            </div>
            
            {/* Simplified Digital Pricing */}
            <div className="bg-gradient-to-br from-purple-500/10 to-pink-500/10 p-8 rounded-2xl border-2 border-purple-500/30 mt-6">
              <div className="text-center mb-6">
                <p className="text-logo-navy-light text-sm mb-2">Starting at</p>
                <p className="text-5xl font-bold bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent">$361</p>
                <p className="text-logo-navy-light text-sm mt-2">2-4 hours available</p>
              </div>
              
              <Button 
                onClick={scrollToContact}
                className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 font-bold"
              >
                Book Premium Digital
              </Button>
            </div>
          </div>
        </div>
        
        {/* View Full Gallery Button */}
        <div className="text-center mt-12">
          <a 
            href="https://www.rawimagesphoto.com/vcbphotos" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-logo-teal hover:bg-logo-teal-dark text-white px-8 py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:scale-105 font-bold">
              <ExternalLink className="w-5 h-5 mr-2" />
              View Gallery of Photos
            </Button>
          </a>
          <p className="text-logo-navy-light text-sm mt-4">
            Browse hundreds of photos from our events
          </p>
        </div>
      </div>
    </section>
  );
};

export default FunGallery;
